export enum PrizeType {
	OneLine,
	TwoLines,
	House,
	Jackpot
}
